/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://codbjrxnmvcjnesyw2txrgukzm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-eufktg55wzfafbuicyivra4qua",
    "aws_cognito_identity_pool_id": "us-east-1:a9971bbe-15ad-49a2-abc4-118346fbf937",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_59CNUZbVa",
    "aws_user_pools_web_client_id": "6vengifakctvp7fvjsjc3fmv5o",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "terryamplify222671e0a4364513b0bb4316fa602af0201211-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
